import React, { useEffect, useRef, useState } from 'react';
import { AuthButtonWrapper } from './Auth.style';
import { Button } from 'components';
import {
  AndroidAuthClientId,
  GoogleAuthClientId,
  IOSAuthClientId,
} from 'environment';
import { ReactComponent as GoogleLogo } from 'assert/images/Common/googleLogo.svg';
import { useDispatch } from 'react-redux';
import { handleGoogleSignup } from 'redux/features/LoginSlice';
import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';

const GoogleLogin = ({ handleGoogleClick }) => {
  const hiddenBtnRef = useRef(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform() && window.google) {
      window.google.accounts.id.initialize({
        client_id: GoogleAuthClientId,
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(hiddenBtnRef.current, {
        theme: 'outline',
        size: 'large',
      });
    }
  }, []);

  const handleCredentialResponse = async (response) => {
    if (response?.credential) {
      setIsLoading(true);
      const payload = {
        idToken: response.credential,
      };
      handleGoogleClick();
      dispatch(handleGoogleSignup(payload))
        .then(() => {
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  const triggerGoogleLogin = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        setIsLoading(true);
        await SocialLogin.initialize({
          google: {
            webClientId: GoogleAuthClientId,
            androidClientId: AndroidAuthClientId,
            iOSClientId: IOSAuthClientId,
            iOSServerClientId: GoogleAuthClientId,
          },
        });

        const loginOptions =
          Capacitor.getPlatform() === 'ios'
            ? {
                provider: 'google',
                options: {
                  scopes: ['profile', 'email'],
                },
              }
            : {
                provider: 'google',
              };

        const { result } = await SocialLogin.login(loginOptions);

        const payload = {
          idToken: result.idToken,
        };
        handleGoogleClick();
        dispatch(handleGoogleSignup(payload))
          .then(() => {
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
          });
      } catch (err) {
        console.error('Native Google login failed:', err);
        setIsLoading(false);
      }
    } else {
      const realButton =
        hiddenBtnRef.current?.querySelector('div[role="button"]');
      realButton?.click();
    }
  };

  return (
    <AuthButtonWrapper>
      <div
        ref={hiddenBtnRef}
        style={{ visibility: 'hidden', position: 'absolute' }}
      />
      <Button
        startIcon={<GoogleLogo />}
        label={isLoading ? 'Loading...' : 'Google'}
        onClick={triggerGoogleLogin}
        variant="outlined"
        className="custom-google-btn"
        disableElevation
        disabled={isLoading}
      />
    </AuthButtonWrapper>
  );
};

export default GoogleLogin;
